import axios from "axios"
import { baseURL } from "../config/api";

export const getGeneralSettings = (tenantId: string) => {
    return getFetch("generalSetting", tenantId)
}

export const getGeneralSetting = (primaryKey: string, tenantId: string) => {
    return getFetch(`generalSetting/${primaryKey}`, tenantId)
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
        },
        params: params
    }).then(response => response.data);
}